export interface INotification {
  id:         string //  "db658c93-e9fb-497e-8acc-ce4fecd3a9ea"
  text:       string
}

export class Notification {
  id:         string
  text:       string

  constructor(notification: INotification) {
    this.id         = notification.id
    this.text       = notification.text
  }
}

export default Notification
